<template>
    <div class="main-container" ref="tRef">
        <el-header ref="titleRef" style="height:45px">用户信息</el-header>
        <el-main ref="summaryRef">
            <el-row>
                <el-col :span="8">用户：<span class="grid-content">{{product.user_name}}</span></el-col>
                <el-col :span="8">所属渠道：<span class="grid-content">{{ product.channel_no }}</span></el-col>
            </el-row>
            
        </el-main>
        <el-header class="flex-row" style="height:45px;">
          商品信息
        </el-header>
        <el-table :data="productInfo" border stripe>
            <el-table-column label="商品名称" prop="product_name">
            </el-table-column>
            <el-table-column label="供应商" width="100" prop="vender_name">
            </el-table-column>
            <el-table-column label="订单来源" width="100" prop="sign_name">
            </el-table-column>
            <el-table-column label="商品类型" prop="type">
                <!-- <template #default="scope">
                    <span class="grid-content" v-if="scope.row.type == 1">
                        线上直充
                    </span>
                    <span class="grid-content" v-else-if="scope.row.type == 2">
                        电子券
                    </span>
                    <span class="grid-content" v-else>
                        甜蜜兑
                    </span>
                </template> -->
            </el-table-column>
            <el-table-column label="数量" prop="quantity"></el-table-column>
            <el-table-column label="单价" prop="price">
            </el-table-column>
            <el-table-column label="实付" width="180" prop="final_amount">
            </el-table-column>
            <el-table-column label="余额支付" width="180" prop="user_money_paid">
            </el-table-column>
            <el-table-column prop="total_amount" label="总金额"></el-table-column>
        </el-table>
        <el-header ref="titleRef" style="height:45px;">订单信息</el-header>
        <el-table :data="couponsInfo" border stripe>
            <el-table-column label="id" prop="id" width="120">
            </el-table-column>
            <el-table-column label="劵码状态" prop="status" width="100">
                <!-- <template #default="scope">
                    <span class="grid-content" v-if="product.status == 0">
                        未使用
                    </span>
                    <span class="grid-content" v-else-if="product.status == 1">
                        已使用
                    </span>
                    <span class="grid-content" v-else>
                        作废
                    </span>
                </template> -->
            </el-table-column>
            <el-table-column label="有效开始时间" prop="valid_from" width="120"></el-table-column>
            <el-table-column label="有效结束时间" prop="valid_to" width="120">
            </el-table-column>
            <el-table-column label="劵码"  prop="card">
                <template #default="scope">
                    <div v-if="scope.row.card">
                        卡号：{{ scope.row.card }}
                    </div>
                    <div v-if="scope.row.result == 0" class="ellipsis">
                        劵码：{{ scope.row.password }}
                    </div>
                    <div v-else class="ellipsis">
                        劵码：{{ scope.row.liePassword }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template #default="scope">
                    <div class="action-list">
                        <el-button 
                                v-if="sign_type==2"
                                :disabled="scope.row.result == 1"
                                type="primary"
                                size="small"
                                @click="toOPen(scope.row.password,scope)"
                                >
                                解码
                        </el-button>
                        <el-button 
                                type="primary"
                                size="small"
                                @click="toCoupon(scope.row)"
                                >
                                换绑
                        </el-button>
                        <el-button 
                                type="primary"
                                size="small"
                                @click="toNote(scope.row)"
                                >
                                备注
                        </el-button>
                        <el-button 
                                type="primary"
                                size="small"
                                @click="openRefundDialog(scope.row.password)"
                                >
                                退款
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-main>
            <el-row>
                <el-col :span="8">订单编号：{{ product.order_no }}<span class="grid-content"></span></el-col>
                <el-col :span="8">订单类型：{{product.type}}
                    <!-- <span class="grid-content" v-if="product.pay_status == 0">
                        待支付
                    </span>
                    <span class="grid-content" v-else-if="product.pay_status == 1">
                        已支付
                    </span>
                    <span class="grid-content" v-else>
                        已取消
                    </span> -->
                </el-col>
                <el-col :span="8">充值账号：{{ product.phone }}<span class="grid-content"></span></el-col>
            </el-row>
            <el-row>
                <el-col :span="8">支付时间：{{ product.paid_at }}<span class="grid-content"></span></el-col>
                <el-col :span="8">创建时间：{{ product.created_at }}<span class="grid-content"></span></el-col>
                <el-col :span="8">退款时间：{{ product.refund_time }}<span class="grid-content"></span></el-col>
            </el-row>
            <el-row>
                <el-col :span="8">退款原因：{{ product.repund_why }}<span class="grid-content"></span></el-col>
            </el-row>
        </el-main>
        <el-main>
            <el-row>
                <el-col :span="10">
                    <el-header style="height:45px;">
                    订单备注信息
                    </el-header>
                    <el-table :data="customMsg" border stripe :height="tableHeight">
                        <el-table-column label="ID" prop="id">
                        </el-table-column>
                        <el-table-column label="备注" width="200" prop="msg">
                        </el-table-column>
                        <el-table-column label="添加人" width="100" prop="admin_name">
                        </el-table-column>
                        <el-table-column label="添加时间" width="150" prop="add_time">
                        </el-table-column>
                    </el-table>
                </el-col>
                <el-col :span="14">
                    <el-header style="height:45px;">
                    操作日志
                    </el-header>
                    <el-table :data="customCardMsg" border stripe :height="tableHeight">
                        <el-table-column label="ID" prop="id">
                        </el-table-column>
                        <!-- <el-table-column label="原券码" prop="card">
                        </el-table-column>
                        <el-table-column label="新券码" prop="new_card">
                        </el-table-column> -->
                        <el-table-column label="备注" width="230" prop="msg">
                        </el-table-column>
                        <el-table-column label="换绑原因" width="100" prop="change_card_msg">
                        </el-table-column>
                        <el-table-column label="添加人" width="100" prop="admin_name">
                        </el-table-column>
                        <el-table-column label="添加时间" width="150" prop="add_time">
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </el-main>
    </div>
    <el-dialog title="换绑" v-model="couponDialog" :before-close="beforeDialogClose">
        <el-form class="form" label-width="150px">
            <el-form-item label="原券码" v-if="coupon.result == 1"  prop="money" style="width:450px">
                <el-input disabled v-model="coupon.liePassword"></el-input>
            </el-form-item>
            <el-form-item label="原券码" v-else prop="money" style="width:450px">
                <el-input disabled v-model="coupon.card"></el-input>
            </el-form-item> 
            <el-form-item v-if="sign_type==2" label="新券码" prop="money" style="width:450px">
                <el-input v-model="coupon.new_card"
                          @input="coupon.new_card = coupon.new_card.replace(/[^0-9a-zA-Z_\-.!@#$%^&*()+,?/]/g, '')"    
                ></el-input>
            </el-form-item>
            <el-form-item label="原卡号" v-if="coupon.coupon_no"  prop="money" style="width:450px">
                <el-input disabled v-model="coupon.coupon_no"></el-input>
            </el-form-item> 
            <el-form-item  v-if="coupon.coupon_no" label="新卡号" prop="money" style="width:450px">
                <el-input v-model="coupon.new_coupon_no"
                          @input="coupon.new_coupon_no = coupon.new_coupon_no.replace(/[^0-9a-zA-Z_\-.!@#$%^&*()+,?/]/g, '')"    
                ></el-input>
            </el-form-item>
            <el-form-item v-if="sign_type==1" label="操作类型：" prop="is_coupon">
                <el-radio-group v-model="coupon.is_coupon">
                    <el-radio :label="1">作废</el-radio>
                    <el-radio :label="2">恢复</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="换绑原因" style="width:450px">
                <el-input type="textarea" :rows="4" maxlength="100" show-word-limit v-model="coupon.change_card_msg"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="beforeDialogClose">取 消</el-button>
            <el-button type="success" @click="submitCoupon()">确 定</el-button>
            </span>
        </template>
    </el-dialog>
    <!-- 备注 -->
    <el-dialog title="备注" v-model="noteDialog" :before-close="beforeNoteDialogClose">
        <el-form class="form" label-width="150px">
            <el-form-item label="备注" required style="width:450px">
                <el-input type="textarea" :rows="4" maxlength="100" show-word-limit v-model="notes.msg"></el-input>
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="beforeNoteDialogClose">取 消</el-button>
            <el-button type="primary" @click="submitNote()">确 定</el-button>
            </span>
        </template>
    </el-dialog>
    <!-- 退款弹框 -->
    <el-dialog title="退款" v-model="refundDialog" :before-close="refundDialogClose">
        <el-form class="form" label-width="100px">
            <el-form-item label="券码">
                <el-input v-model="refund.coupon_no" disabled></el-input>
            </el-form-item>
            <el-form-item label="原因" required>
                <el-input type="textarea" :rows="4" maxlength="30" show-word-limit v-model="refund.reason"></el-input>
            </el-form-item>
            <el-form-item>
                注意：退款后券码将不完全作废，请慎用
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
            <el-button @click="refundDialogClose">取 消</el-button>
            <el-button type="primary" @click="submitRefund()">确认退款</el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { useRoute, useRouter } from 'vue-router'
import { toRefs, defineComponent, ref, reactive, getCurrentInstance, nextTick,  onMounted } from 'vue'
import { useStore } from '@/store/index'
import { getQueryByName } from '@/utils'
import { saveCouponRefund } from '@/apis/electron'
export default defineComponent({
setup () {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    
    const state = reactive({
        order_id:route.query.order_id,
        order_no:route.query.order_no,
        sign_type:route.query.sign_type,
        product:{
            shop_name:'',        //门店名称
            order_no:'',        //订单号
            product_name:'',        //商品名称
            type:'',        //商品类型
            status_name:'',        //订单类型
            coupon_no:'',        //券码
            created_at:'',      //订单创建时间
        },
        productInfo:[],
        customMsg:[],       //备注信息
        customCardMsg:[],   //操作日志
        couponDialog:false,//换绑弹窗
        noteDialog:false,//备注弹窗
        tableHeight: 0, // table 动态高度

    })
    const coupon = reactive({
        id:'',              //券码id
        order_id:route.query.order_id,
        type:route.query.sign_type,    //类型
        is_coupon:'',   //操作类型
        card:'',//券码
        change_card_msg:'',     //换绑原因
        new_card:'' ,            //新券码
        coupon_no:'',           //原卡号
        new_coupon_no:'',        //新卡号
        liePassword:'',         //解码后
        result:'',              //是否解码
    })
    const notes = reactive({
        order_id:route.query.order_id,
        type:route.query.sign_type,    //类型
        msg:'',     //订单备注
    })
    const couponsInfo = ref([])
    const productInfo = ref([])
    //解码
    const toOPen = (password,scope) => {        
        proxy.$http.post('/coupon/coupon/direct_card_decrypt',{channel_no:state.product.channel_no,password}).then((res) => {
            const { code, data, msg } = res
            if (code == 200) { 
                scope.row.liePassword = data
                scope.row.result =1
                return proxy.$message({ type: 'success', message: msg })
            }else if(code != 200) {
                return proxy.$message({ type: 'error', message: msg }) 
            }
        })
    }
    //打开换绑弹窗
    const toCoupon = (row) => {
        state.couponDialog = true
        coupon.result = row.result
        if(state.sign_type==2){
            coupon.liePassword = row.liePassword
            coupon.card = row.password
            coupon.coupon_no = row.card
        }else{
            coupon.card = row.card
        }
        coupon.id = row.id
    }
    //打开备注弹窗
    const toNote = (row) => {
        state.noteDialog = true
    }

    //提交换绑信息
    const submitCoupon = () => {
        proxy.$confirm(`确定要换绑吗？`, '提示', {
            type: 'warning',
            dangerouslyUseHTMLString: true
        }).then(() => {
            proxy.$http.get('/cake_api/serviceCouponOrderSave',coupon).then(res => {
                const {code,data,msg} = res 
                if(code == 200){
                    proxy.$message({type:'success',message:msg});
                    beforeDialogClose()
                    let urlOrder = sessionStorage.getItem('orderList')
                    let card = getQueryByName(urlOrder, 'card')
                    if (card && data.length) {
                        urlOrder = urlOrder.replace(card, data)
                        sessionStorage.setItem('orderList', urlOrder)
                    }
                    proxy.$http.get(urlOrder).then(resOrder => { // 请求列表接口是为了刷新后台缓存（redis）
                        if(resOrder.code != 200){
                            proxy.$message({type:'error',message:resOrder.msg});
                        }
                        getOrderDetail()
                    })
                }else{
                    proxy.$message({type:'error',message:msg});
                }
            })
        }).catch(() => {

        })
    }
    //提交备注信息
    const submitNote = () => {
        proxy.$http.get('/cake_api/serviceCouponOrderSave?order_id',notes).then((res) => {
            const { code, data, msg } = res
            if (code == 200) { 
                proxy.$message({ type: 'success', message: msg }) 
                beforeNoteDialogClose()
                getOrderDetail()
            }else {
                proxy.$message({ type: 'error', message: msg }) 
            }
            
        })
    }
    // 关闭换绑弹框前清空数据
    const beforeDialogClose = () => {
        state.couponDialog = false
        coupon.id = ''
        // coupon.order_id = ''
        // coupon.type = ''
        coupon.is_coupon = ''
        coupon.card = ''
        coupon.change_card_msg = ''
        coupon.new_card = ''
        coupon.coupon_no = ''
        coupon.new_coupon_no = ''
    }
    // 关闭备注弹框前清空数据
    const beforeNoteDialogClose = () => {
        state.noteDialog = false
        // notes.order_id = ''
        // notes.type = ''
        notes.msg = ''
    }
    // 获取订单详情
    const getOrderDetail = () => {
        const {order_id,order_no,sign_type} = state
        proxy.$http.get(`/cake_api/serviceCouponOrderInfo?order_id=${order_id}&order_no=${order_no}&sign_type=${sign_type}`).then((res) => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            state.product = data
            // state.productInfo = Object.values(data);
            productInfo.value = [data]
            if(productInfo.value[0].sign_name == '平台'){
                notes.type = 1
            }else {
                notes.type = 2
            }
            couponsInfo.value = data.coupon_info
            const newCouponsInfo = couponsInfo.value.map((item) => {
                item.liePassword = "";
                return item;
            });
            state.customMsg = data.kf_msg
            state.customCardMsg = data.kf_card_msg
        })
    }
    // 设置 table 高度
    const setTableHeight = () => {
        nextTick(() => {
            let headerHeight = 50,  // 头部高度
                // filterHeight = proxy.$refs.filterContainer.offsetHeight + 30, // 搜索条件框高度 + 间距
                paginationHeight = 62 // 分页栏高度 + 与 table 之间的间距
            state.tableHeight = window.innerHeight - headerHeight - paginationHeight
        })
    }
    onMounted(() => {
        route.query.order_id&&route.query.order_no&&getOrderDetail()
        // 设置 table 高度
        setTableHeight()
        // 监听窗口变化，重置 table 高度
        window.onresize = setTableHeight
    })

    /************************************ 退款弹框 --begin ************************************/
    const refund = ref({
        coupon_no: '',
        reason: ''
    })
    const refundDialog = ref(false)
    const openRefundDialog = (coupon_no) => {
        refund.value.coupon_no = coupon_no
        refundDialog.value = true
    }
    const refundDialogClose = () => {
        refund.value.coupon_no = ''
        refund.value.reason = ''
        refundDialog.value = false
    }
    const submitRefund = async () => {
        if (!refund.value.reason) { return proxy.$message({ type: 'error', message: '请输入退款原因' }) }
        
        const { code, data, msg } = await saveCouponRefund(refund.value)
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }

        proxy.$message({ type: 'success', message: '操作成功' })
    }
    /************************************ 退款弹框 --end ************************************/
    return {
        ...toRefs(state), 
        coupon,notes,getOrderDetail,couponsInfo,productInfo,toCoupon,beforeDialogClose,
        toNote,beforeNoteDialogClose,submitCoupon,submitNote,toOPen,
        refund, refundDialog, openRefundDialog, refundDialogClose, submitRefund
    }
}
})
</script>

<style lang="stylus" scoped>
    .ellipsis {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .main-container
        padding 20px
        font-size 14px
    .el-header, .el-footer {
        background-color: #B3C0D1;
        color: #333;
        text-align: left;
        line-height: 45px;
    }
    .el-header.flex-row
        span:not(:last-child)
            margin-right 35px
            &:first-child
                margin-right 20px

    .el-main {
        background-color: #E9EEF3;
        color: #333;
    }
    .el-row {
        margin-bottom: 18px;
        &:last-child {
            margin-bottom: 0;
        }
    }
    .grid-content
        display inline-block
        vertical-align top
        width 70%
    .flex-bar
        display flex
        align-items center
        .right
            margin-left 8px
            p:not(:first-child)
                margin-top 10px
            .title
                max-width 80%
                font-size 12px
                font-weight bold
    .total-bar
        margin-top 10px
        margin-bottom 0
        text-align right
        line-height 48px
</style>